var React = require('react');

function BgPageBannerV2TopInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2c4965","d":"M1366,328.78,542,6.54C530.41,2,515.06-.17,499.88,0c-15.35-.18-30.83,1.93-42.45,6.47L0,184.08V331.93H1366Z"}));
}

BgPageBannerV2TopInline.defaultProps = {"aria-hidden":"true","data-name":"Calque 1","viewBox":"0 0 1366 331.93"};

module.exports = BgPageBannerV2TopInline;

BgPageBannerV2TopInline.default = BgPageBannerV2TopInline;
